import { gql, useMutation } from '@apollo/client'

import { cleanRequest } from './cleanRequest'
import { generalClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertConfig($input: ConfigInput) {
    upsertConfig(input: $input) {
      id
    }
  }
`

export const useSaveConfig = () => {
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Configs', 'Config'], client: generalClient })
  const closeModal = useCloseModal()

  const handleRequest = form => {
    const input = cleanRequest(form)

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) closeModal()
    })
  }

  return [handleRequest, state]
}
